export const THRESHOLD_M_MIN = 0;
export const THRESHOLD_M_MAX = 1;
export const THRESHOLD_M_STEP = 0.01;
export const THRESHOLD_M_DECIMAL_PLACES = 2;
export const DEFAULT_THRESHOLD_M = 0.1;

export const formatMetersDisplay = (meters: number, locale?: Intl.LocalesArgument) => {
  if (!Number.isFinite(meters)) return 'Infinity';

  const formattedMeters = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(meters);
  return `${formattedMeters} m`;
};

export const clampThresholdMeters = (meters: number, decimalPlaces = THRESHOLD_M_DECIMAL_PLACES) => {
  if (!Number.isFinite(meters)) return THRESHOLD_M_MIN;
  const precision = 10 ** decimalPlaces;
  const rounded = Math.round(meters * precision) / precision;
  return Math.min(THRESHOLD_M_MAX, Math.max(THRESHOLD_M_MIN, Number(rounded.toFixed(decimalPlaces))));
};

export const isUsableThresholdMeters = (meters: number | null | undefined, { allowZero = false }: { allowZero?: boolean } = {}) =>
  typeof meters === 'number' &&
  Number.isFinite(meters) &&
  (allowZero ? meters >= THRESHOLD_M_MIN : meters > THRESHOLD_M_MIN) &&
  meters <= THRESHOLD_M_MAX;
